export class TipoEntrega {
  constructor(
    public id?: number,
    public descripcion?: string,
    public web: boolean = true
  ) { }
}